import { http } from '../../../api/axios';
import { shopPrefix } from '../../../config';
import { Pagination } from '../../../../models/Pagination';
import { ProductFilter, ProductSearchResponseOut } from '../../../store/api';

interface ParameterTypes {
    q?: string;
    scope: string;
    pagination: Pagination;
    filterMap: ProductFilter;
    loanFormat: string | null;
    enabled?: boolean;
    searchLabel?: string;
    refine?: string | null;
    shopLanguage: string | undefined;
}

export const fetchCatalogueSearchResultProducts = ({
    q,
    scope,
    pagination,
    filterMap,
    loanFormat,
    searchLabel,
    refine,
    shopLanguage
}: ParameterTypes) => {
    const params = {
        ...pagination,
        loanFormat,
        q,
        searchLabel,
        refine,
        shopLanguage
    };

    return http
        .post<ProductSearchResponseOut>(`${shopPrefix}/v1/catalogue/search/products/:scope`, filterMap, {
            params,
            pathParams: { scope }
        })
        .then(response => response.data);
};
